import DPR from './DPR.js'

export default class CursorHighlighter {
  constructor(dragCamera, drawingToolKit) {
    this.showCursorPixel = false;
    this._dragCamera = dragCamera;
    this._drawingToolKit = drawingToolKit;
    this._lastCursorX = 0;
    this._lastCursorY = 0;
    this._drawCalled = false;
    this._cleared = true;
    this._draw = this._draw.bind(this);
    this._clear = this._clear.bind(this);
    this._elCanvas = document.querySelector('#frontCanvas');
    this._ctx = this._elCanvas.getContext('2d');

    const elMainCanvas = document.querySelector('#mainCanvas');
    elMainCanvas.addEventListener('mousemove', e => {
      this._lastCursorX = DPR.mul(e.x);
      this._lastCursorY = DPR.mul(e.y);
      this.requestDraw();
    });
    elMainCanvas.addEventListener('mouseout', () => {
      if(!this._cleared) {
        requestAnimationFrame(this._clear);
      }
    });
  }
  _draw() {
    const ctx = this._ctx;
    ctx.clearRect(0, 0, this._elCanvas.width, this._elCanvas.height);
    const [imageX, imageY] = this._dragCamera.localPtToWorldPt(this._lastCursorX, this._lastCursorY);
    const [startX, startY, endX, endY] = this._drawingToolKit.getThickRect(imageX, imageY);
    if(startX < endX && startY < endY) {
      const [lx1, ly1] = this._dragCamera.worldPtToLocalPtD(startX, startY, false);
      const [lx2, ly2] = this._dragCamera.worldPtToLocalPtD(endX, endY, false);
      const lw = lx2 - lx1 + 1;
      const lh = ly2 - ly1 + 1;
      const style = getComputedStyle(document.documentElement);
      ctx.save();
      ctx.fillStyle = style.getPropertyValue('--color-highlight');
      ctx.strokeStyle = style.getPropertyValue('--color-highlight2');
      ctx.globalAlpha = .75;
      ctx.fillRect(lx1, ly1, lw, lh);
      ctx.strokeRect(lx1, ly1, lw, lh);
      ctx.restore();
      this._cleared = false;
    }
    this._drawCalled = false;
  }
  _clear() {
    this._ctx.clearRect(0, 0, this._elCanvas.width, this._elCanvas.height);
    this._cleared = true;
  }
  requestDraw() {
    if(this.showCursorPixel || this._drawingToolKit.getMode() === 'eraser') {
      if(!this._drawCalled) {
        requestAnimationFrame(this._draw);
        this._drawCalled = true;
      }
    } else if(!this._cleared) {
      requestAnimationFrame(this._clear);
    }
  }
  resize(width, height) {
    this._elCanvas.width = width;
    this._elCanvas.height = height;
    this._elCanvas.style.transform = `scale(${DPR.div(1)})`;
  }
}
